export const OPEN_STRING = 0
export const MUTED_STRING = null

export const CHORD_SHAPES = {
  C9: [
    { fret: 3, str: 1 },
    { fret: 3, str: 2 },
    { fret: 3, str: 3 },
    { fret: 2, str: 4 },
    { fret: 3, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  D: [
    { fret: 2, str: 1 },
    { fret: 3, str: 2 },
    { fret: 2, str: 3 },
    { fret: OPEN_STRING, str: 4 },
    { fret: MUTED_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  'D/F#': [
    { fret: 2, str: 1 },
    { fret: 3, str: 2 },
    { fret: 2, str: 3 },
    { fret: OPEN_STRING, str: 4 },
    { fret: OPEN_STRING, str: 5 },
    { fret: 2, str: 6 },
  ],
  Dsus2: [
    { fret: OPEN_STRING, str: 1 },
    { fret: 3, str: 2 },
    { fret: 2, str: 3 },
    { fret: OPEN_STRING, str: 4 },
    { fret: MUTED_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  Dsus4: [
    { fret: 3, str: 1 },
    { fret: 3, str: 2 },
    { fret: 2, str: 3 },
    { fret: OPEN_STRING, str: 4 },
    { fret: MUTED_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  D7: [
    { fret: 2, str: 1 },
    { fret: 1, str: 2 },
    { fret: 2, str: 3 },
    { fret: OPEN_STRING, str: 4 },
    { fret: MUTED_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  D7sus2: [
    { fret: OPEN_STRING, str: 1 },
    { fret: 1, str: 2 },
    { fret: 2, str: 3 },
    { fret: OPEN_STRING, str: 4 },
    { fret: MUTED_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  D7sus4: [
    { fret: 3, str: 1 },
    { fret: 1, str: 2 },
    { fret: 2, str: 3 },
    { fret: OPEN_STRING, str: 4 },
    { fret: MUTED_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  Ddim: [
    { fret: 1, str: 1 },
    { fret: 3, str: 2 },
    { fret: 1, str: 3 },
    { fret: OPEN_STRING, str: 4 },
    { fret: MUTED_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  Daug: [
    { fret: 2, str: 1 },
    { fret: 3, str: 2 },
    { fret: 3, str: 3 },
    { fret: OPEN_STRING, str: 4 },
    { fret: MUTED_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  E: [
    { fret: OPEN_STRING, str: 1 },
    { fret: OPEN_STRING, str: 2 },
    { fret: 1, str: 3 },
    { fret: 2, str: 4 },
    { fret: 2, str: 5 },
    { fret: OPEN_STRING, str: 6 },
  ],
  E7: [
    { fret: OPEN_STRING, str: 1 },
    { fret: OPEN_STRING, str: 2 },
    { fret: 1, str: 3 },
    { fret: OPEN_STRING, str: 4 },
    { fret: 2, str: 5 },
    { fret: OPEN_STRING, str: 6 },
  ],
  Eadd9: [
    { fret: 2, str: 1 },
    { fret: OPEN_STRING, str: 2 },
    { fret: 1, str: 3 },
    { fret: 2, str: 4 },
    { fret: 2, str: 5 },
    { fret: OPEN_STRING, str: 6 },
  ],
  Em: [
    { fret: OPEN_STRING, str: 1 },
    { fret: OPEN_STRING, str: 2 },
    { fret: OPEN_STRING, str: 3 },
    { fret: 2, str: 4 },
    { fret: 2, str: 5 },
    { fret: OPEN_STRING, str: 6 },
  ],
  'Em/G': [
    { fret: 3, str: 1 },
    { fret: OPEN_STRING, str: 2 },
    { fret: OPEN_STRING, str: 3 },
    { fret: 2, str: 4 },
    { fret: 2, str: 5 },
    { fret: 3, str: 6 },
  ],
  Em7: [
    { fret: 3, str: 1 },
    { fret: 3, str: 2 },
    { fret: OPEN_STRING, str: 3 },
    { fret: 2, str: 4 },
    { fret: 2, str: 5 },
    { fret: OPEN_STRING, str: 6 },
  ],
  A: [
    { fret: OPEN_STRING, str: 1 },
    { fret: 2, str: 2 },
    { fret: 2, str: 3 },
    { fret: 2, str: 4 },
    { fret: OPEN_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  Aaug: [
    { fret: 1, str: 1 },
    { fret: 2, str: 2 },
    { fret: 2, str: 3 },
    { fret: 3, str: 4 },
    { fret: OPEN_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  Asus2: [
    { fret: OPEN_STRING, str: 1 },
    { fret: OPEN_STRING, str: 2 },
    { fret: 2, str: 3 },
    { fret: 2, str: 4 },
    { fret: OPEN_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  Asus2sus4: [
    { fret: OPEN_STRING, str: 1 },
    { fret: OPEN_STRING, str: 2 },
    { fret: 2, str: 3 },
    { fret: OPEN_STRING, str: 4 },
    { fret: OPEN_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  Asus4: [
    { fret: OPEN_STRING, str: 1 },
    { fret: 3, str: 2 },
    { fret: 2, str: 3 },
    { fret: 2, str: 4 },
    { fret: OPEN_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  A7: [
    { fret: OPEN_STRING, str: 1 },
    { fret: 2, str: 2 },
    { fret: OPEN_STRING, str: 3 },
    { fret: 2, str: 4 },
    { fret: OPEN_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  Am: [
    { fret: OPEN_STRING, str: 1 },
    { fret: 1, str: 2 },
    { fret: 2, str: 3 },
    { fret: 2, str: 4 },
    { fret: OPEN_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  // Amb6: [
  //   { fret: 1, str: 1 },
  //   { fret: 1, str: 2 },
  //   { fret: 2, str: 3 },
  //   { fret: 2, str: 4 },
  //   { fret: OPEN_STRING, str: 5 },
  //   { fret: MUTED_STRING, str: 6 },
  // ],
  Am7: [
    { fret: OPEN_STRING, str: 1 },
    { fret: 1, str: 2 },
    { fret: OPEN_STRING, str: 3 },
    { fret: 2, str: 4 },
    { fret: OPEN_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  G: [
    { fret: 3, str: 1 },
    { fret: 3, str: 2 },
    { fret: OPEN_STRING, str: 3 },
    { fret: OPEN_STRING, str: 4 },
    { fret: 2, str: 5 },
    { fret: 3, str: 6 },
  ],
  C: [
    { fret: OPEN_STRING, str: 1 },
    { fret: 1, str: 2 },
    { fret: OPEN_STRING, str: 3 },
    { fret: 2, str: 4 },
    { fret: 3, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  Csus2: [
    { fret: 3, str: 1 },
    { fret: 3, str: 2 },
    { fret: OPEN_STRING, str: 3 },
    { fret: OPEN_STRING, str: 4 },
    { fret: 3, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  Csus4: [
    { fret: 1, str: 1 },
    { fret: 1, str: 2 },
    { fret: OPEN_STRING, str: 3 },
    { fret: 3, str: 4 },
    { fret: 3, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  Csus2sus4: [
    { fret: 3, str: 1 },
    { fret: 3, str: 2 },
    { fret: 5, str: 3 },
    { fret: 3, str: 4 },
    { fret: 3, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  'C/G': [
    { fret: OPEN_STRING, str: 1 },
    { fret: 1, str: 2 },
    { fret: OPEN_STRING, str: 3 },
    { fret: 2, str: 4 },
    { fret: 3, str: 5 },
    { fret: 3, str: 6 },
  ],
  'C/E': [
    { fret: OPEN_STRING, str: 1 },
    { fret: 1, str: 2 },
    { fret: OPEN_STRING, str: 3 },
    { fret: 2, str: 4 },
    { fret: 3, str: 5 },
    { fret: OPEN_STRING, str: 6 },
  ],
  Cmaj7: [
    { fret: OPEN_STRING, str: 1 },
    { fret: OPEN_STRING, str: 2 },
    { fret: OPEN_STRING, str: 3 },
    { fret: 2, str: 4 },
    { fret: 3, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  Bdim: [
    { fret: MUTED_STRING, str: 1 },
    { fret: 3, str: 2 },
    { fret: 4, str: 3 },
    { fret: 3, str: 4 },
    { fret: 2, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  Dm: [
    { fret: 1, str: 1 },
    { fret: 3, str: 2 },
    { fret: 2, str: 3 },
    { fret: OPEN_STRING, str: 4 },
    { fret: MUTED_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  Dm7: [
    { fret: 1, str: 1 },
    { fret: 1, str: 2 },
    { fret: 2, str: 3 },
    { fret: OPEN_STRING, str: 4 },
    { fret: MUTED_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  'Dm/F': [
    { fret: 1, str: 1 },
    { fret: 3, str: 2 },
    { fret: 2, str: 3 },
    { fret: OPEN_STRING, str: 4 },
    { fret: OPEN_STRING, str: 5 },
    { fret: 1, str: 6 },
  ],
  Fmaj7: [
    { fret: OPEN_STRING, str: 1 },
    { fret: 1, str: 2 },
    { fret: 2, str: 3 },
    { fret: 3, str: 4 },
    { fret: MUTED_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  E5: [
    { fret: MUTED_STRING, str: 1 },
    { fret: MUTED_STRING, str: 2 },
    { fret: MUTED_STRING, str: 3 },
    { fret: 2, str: 4 },
    { fret: 2, str: 5 },
    { fret: OPEN_STRING, str: 6 },
  ],
  // Half-diminished (m7b5) chords
  // Am7b5: A, C, Eb, G - voicing x-0-1-0-1-x
  Am7b5: [
    { fret: MUTED_STRING, str: 1 },
    { fret: 1, str: 2 }, // C
    { fret: OPEN_STRING, str: 3 }, // G
    { fret: 1, str: 4 }, // Eb
    { fret: OPEN_STRING, str: 5 }, // A
    { fret: MUTED_STRING, str: 6 },
  ],
  // Dm7b5: D, F, Ab, C - voicing 1-1-1-0-x-x
  Dm7b5: [
    { fret: 1, str: 1 }, // F
    { fret: 1, str: 2 }, // C
    { fret: 1, str: 3 }, // Ab
    { fret: OPEN_STRING, str: 4 }, // D
    { fret: MUTED_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  // Em7b5: E, G, Bb, D - voicing 3-3-3-2-x-x
  Em7b5: [
    { fret: 3, str: 1 }, // G
    { fret: 3, str: 2 }, // D
    { fret: 3, str: 3 }, // Bb
    { fret: 2, str: 4 }, // E
    { fret: MUTED_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
  // A7b5: A, C#, Eb, G - voicing x-0-1-0-2-x
  A7b5: [
    { fret: MUTED_STRING, str: 1 },
    { fret: 2, str: 2 }, // C#
    { fret: OPEN_STRING, str: 3 }, // G
    { fret: 1, str: 4 }, // Eb
    { fret: OPEN_STRING, str: 5 }, // A
    { fret: MUTED_STRING, str: 6 },
  ],
  // A7#5: A, C#, E#(F), G - keep the working voicing
  'A7#5': [
    { fret: 1, str: 1 },
    { fret: 2, str: 2 },
    { fret: OPEN_STRING, str: 3 },
    { fret: 3, str: 4 },
    { fret: OPEN_STRING, str: 5 },
    { fret: MUTED_STRING, str: 6 },
  ],
}

export type ChordShape = keyof typeof CHORD_SHAPES
